const MinusIcon = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.95264 11.7871H17.2475"
      stroke="#42464C"
      strokeWidth="1.41186"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MinusIcon;
